import { useContext } from 'react'

import MediaContext from 'sb-hooks/MediaContext'


const useMedia = () => useContext(MediaContext)


export default useMedia
